const listStyleType = {
  name: "list-style-type",
  path: "/list-style-type",
  title: "list-style-type",
  description: "Utilities for controlling the bullet/number style of lists.",
  value: {
    "list-style-type": {
      "list-none": "none",
      "list-disc": "disc",
      "list-decimal": "decimal",
      "list-square": "square",
      "list-circle": "circle",
      "list-upper-roman": "upper-roman"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<ul class="list-disc pl-6">
  <li>Disc bullet</li>
  <li>Another item</li>
</ul>
<ul class="list-decimal pl-6">
  <li>Decimal numbers</li>
  <li>Another item</li>
</ul>
<ul class="list-square pl-6">
  <li>Square bullet</li>
  <li>Another item</li>
</ul>
<ul class="list-circle pl-6">
  <li>Circle bullet</li>
  <li>Another item</li>
</ul>
<ul class="list-upper-roman pl-6">
  <li>Upper Roman</li>
  <li>Another item</li>
</ul>
<ul class="list-none pl-6">
  <li>No marker</li>
  <li>Another item</li>
</ul>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">list-disc</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">list-decimal</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">list-square</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">list-circle</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">list-upper-roman</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">list-none</code> to control the marker style.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-disc</small>
          <ul class="list-disc pl-6">
            <li>Disc bullet</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-decimal</small>
          <ul class="list-decimal pl-6">
            <li>Decimal numbers</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-square</small>
          <ul class="list-square pl-6">
            <li>Square bullet</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-circle</small>
          <ul class="list-circle pl-6">
            <li>Circle bullet</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-upper-roman</small>
          <ul class="list-upper-roman pl-6">
            <li>Upper Roman</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-none</small>
          <ul class="list-none pl-6">
            <li>No marker</li>
            <li>Another item</li>
          </ul>
        </div>
      </div>
      `
    }
  ]
}
export default listStyleType;

<div className="list-disc list-list-none list-decimal list-square list-circle list-upper-roman"></div>